const isLetter = (char: string) =>
  /^[a-zA-Z\u00C0-\u017F\u0100-\u024F]$/.test(char)

export const getInitials = (fullName: string) => {
  if (!fullName) return 'NA'
  const [first, last] = fullName.split(' ')
  const firstInitial = first?.[0] && isLetter(first[0]) ? first[0] : ''
  const lastInitial = last?.[0] && isLetter(last[0]) ? last[0] : ''
  const result = firstInitial + lastInitial
  return result || 'NA'
}
